import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
import { showerAccessoriesThumbnail } from '../../../bvComponent/core/assets';
import LargeCornerSeat from "../subparts/showerAccessories/largeCornerSeat";
import SoapDish from "../subparts/showerAccessories/soapDish";
import CornerCaddie from "../subparts/showerAccessories/cornerCaddie";
import LargeCornerCaddie from "../subparts/showerAccessories/largeCornerCaddie";
import GrabBar from "../subparts/showerAccessories/grabBar";
import CornerShelf from "../subparts/showerAccessories/cornerShelf";
import ShowerPod from "../subparts/showerAccessories/showerPod";
import Seats from "../subparts/showerAccessories/seats";
import ShowerRod from "../subparts/showerAccessories/showerRod";
import ToiletBrush from "../subparts/showerAccessories/toiletBrush";
import PaperHolder from "../subparts/showerAccessories/paperHolder";
import RobeHook from "../subparts/showerAccessories/robeHook";
import TowelBar from "../subparts/showerAccessories/towelBar";
import TowelRing from "../subparts/showerAccessories/towelRing";
import GlassHolder from "../subparts/showerAccessories/glassHolder";
import TowelRack from "../subparts/showerAccessories/towelRack";
import Wainscoting from "../subparts/showerAccessories/wainscoting";
import Towel from "../subparts/showerAccessories/towel";
import TowelTowelRing from "../subparts/showerAccessories/towelTowelRing";
import TowelTowelBar from "../subparts/showerAccessories/towelTowelBar";
import TowelTowelHook from "../subparts/showerAccessories/towelTowelHook";
import ShampooShelf from "../subparts/showerAccessories/shampooShelf";
import SeatPad from "../subparts/showerAccessories/seatPad";
import LShapedGrabBar from "../subparts/showerAccessories/lShapedGrabBar";

export class ShowerAccessories extends Part {
  static id = 'Shower Accessories';

  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partThumbnail = showerAccessoriesThumbnail;
    this.partName = 'Shower Accessories';
    this.translateId = "visualizer.bathroom.accessories";
    this.relatedItems = [];

    // related items
    this.soapDish = null;
    this.largeCornerSeat = null;
    this.largeCornerCaddie = null;
    this.cornerCaddie = null;
    this.smallCornerShelf = null;
    this.grabBar = null;
    this.showerPod = null;
    this.seats = null;
    this.showerRod = null;
    this.robeHook = null;
    this.paperHolder = null;
    this.toiletBrush = null;
    this.towelBar = null;
    this.towel = null;
    this.towelTowelRing = null;
    this.towelTowelBar = null;
    this.towelTowelHook = null;
    this.shampooShelf = null;
    this.seatPad = null;
    this.lShapedGrabBar = null;

    //current active caddie type
    this.caddie_type = "corner_shelf";
    this.relatedGroupNames = ["Soap Dish", "Large Corner Seat", "Large Corner Caddie", "Corner Caddie", "Grab Bar",
      "Robe Hook", "Paper Holder", "Toilet Brush", "Shower Rod", "Corner Shelf", "Shower Pod", "Seats", "Towel Bar",
      "Towel Rack", "Towel Ring", "Glass Holder", "Wainscoting", "Shampoo Shelf", "Seat Pad", "L Shaped Grab Bar"];
  }
  load(dbFeature, loadFeature = true) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Soap Dish":
        relatedItemName = "soapDish";
        RelatedItemClass = SoapDish;
        break;
      case "Large Corner Seat":
        relatedItemName = "largeCornerSeat";
        RelatedItemClass = LargeCornerSeat;
        break;
      case "Large Corner Caddie":
        relatedItemName = "largeCornerCaddie";
        RelatedItemClass = LargeCornerCaddie;
        break;
      case "Corner Caddie":
        relatedItemName = "cornerCaddie";
        RelatedItemClass = CornerCaddie;
        break;
      case "Grab Bar":
        relatedItemName = "grabBar";
        RelatedItemClass = GrabBar;
        break;
      case "Robe Hook":
        relatedItemName = "robeHook";
        RelatedItemClass = RobeHook;
        break;
      case "Paper Holder":
        relatedItemName = "paperHolder";
        RelatedItemClass = PaperHolder;
        break;
      case "Toilet Brush":
        relatedItemName = "toiletBrush";
        RelatedItemClass = ToiletBrush;
        break;
      case "Shower Rod":
        relatedItemName = "showerRod";
        RelatedItemClass = ShowerRod;
        break;
      case "Corner Shelf":
      case "Small Corner Shelf":
        relatedItemName = "cornerShelf";
        RelatedItemClass = CornerShelf;
        break;
      case "Shower Pod":
      case "Storage Pod":
      case "Storage Pods":
        relatedItemName = "showerPod";
        RelatedItemClass = ShowerPod;
        break;
      case "Seats":
      case "flip-Up Seat":
      case "Flip-Up Seat":
        relatedItemName = "seats";
        RelatedItemClass = Seats;
        break;
      case "Towel Bar":
        relatedItemName = "towelBar";
        RelatedItemClass = TowelBar;
        break;
      case "Towel Rack":
        relatedItemName = "towelRack";
        RelatedItemClass = TowelRack;
        break;
      case "Towel Ring":
        relatedItemName = "towelRing";
        RelatedItemClass = TowelRing;
        break;
      case "Towel":
      case "towel":
      case "Towels": {
        if (dbFeature.metaData && Array.isArray(dbFeature.metaData["MountPosition"]) && dbFeature.metaData["MountPosition"].length) {
          if (dbFeature.metaData["MountPosition"][0] === "TowelRing") {
            relatedItemName = "towelTowelRing";
            RelatedItemClass = TowelTowelRing;
          } else if (dbFeature.metaData["MountPosition"][0] === "TowelBar" || dbFeature.metaData["MountPosition"][0] === "TowelTowelBar") {
            relatedItemName = "towelTowelBar";
            RelatedItemClass = TowelTowelBar;
          } else if (dbFeature.metaData["MountPosition"][0] === "TowelHook") {
            relatedItemName = "towelTowelHook";
            RelatedItemClass = TowelTowelHook;
          } else {
            relatedItemName = "towel";
            RelatedItemClass = Towel;
          }
        } else {
          relatedItemName = "towel";
          RelatedItemClass = Towel;
        }
        break;
      }
      case "Glass Holder":
        relatedItemName = "glassHolder";
        RelatedItemClass = GlassHolder;
        break;
      case "Wainscoting":
        relatedItemName = "wainscoting";
        RelatedItemClass = Wainscoting;
        break;
      case "Shampoo Shelf":
        relatedItemName = "shampooShelf";
        RelatedItemClass = ShampooShelf;
        break;
      case "Seat Pad":
        relatedItemName = "seatPad";
        RelatedItemClass = SeatPad;
        break;
      case "L Shaped Grab Bar":
        relatedItemName = "lShapedGrabBar";
        RelatedItemClass = LShapedGrabBar;
        break;

    }
    return this.loadCommon(relatedItemName, RelatedItemClass, dbFeature, loadFeature)
  }

}

